import React from 'react';

// Styles & Assets
import styles from './DialogAssignDevice.module.css';

// Services
import { getFullName } from '../../../services/getPatientAtribute';
import { getUser } from '../../../services/Auth';
import { getLastLoan } from '../../../services/DevicesHelpers';
import { getEnvironmentApiUrl } from '../../../services/General';

// Context
import PatientsContext from '../../../context/PatientsContext';

// Hooks
import { useContext, useState } from 'react';
import useHttp from '../../../hooks/useHttp';

// Components
import CheckboxButton from '../../UI/CheckboxButton/CheckboxButton';
import CancelConfirmButtons from '../../UI/CancelConfirmButtons/CancelConfirmButtons';
import Searchbar from '../../UI/Searchbar/Searchbar';

// Interfaces
import { Device, DeviceLoanPatient } from '../../../interfaces/Device';

// Language
import { useTranslation } from 'react-i18next';

const DialogAssignDevice: React.FC<{
    device: Device,
    assignDeviceLocally: (deviceLoanPatient: DeviceLoanPatient) => void
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>
}> = ({ device, assignDeviceLocally, setShowModal }) => {

    const { t } = useTranslation();

    const patientsContext = useContext(PatientsContext);

    const { sendRequest: LinkDevice } = useHttp<DeviceLoanPatient>();

    const [selectedPatientID, setSelectedPatientID] = useState<number | null>(getLastLoan(device.loans)?.patient_id || null);
    const [filterQuery, setFilterQuery] = useState<string>('');

    const changeSearchbar = (evt: React.ChangeEvent<HTMLInputElement>) =>
        setFilterQuery(evt.target.value);

    const handleClickPatient = (patientID: number | null) =>
        setSelectedPatientID(patientID || null);

    const handleConfirm = () => {
        LinkDevice({
            url: getEnvironmentApiUrl() + 'device_loan',
            method: 'POST',
            body: {
                device_id: device.id,
                patient_id: selectedPatientID,
                loan_date: new Date().toISOString(),
                loan_user_id: getUser().id,
                deleted: false,
            }
        }, (data: DeviceLoanPatient) => assignDeviceLocally(data));
        setShowModal(false);
    };

    const filteredPatients = patientsContext.patients.filter(patient =>
        getFullName(patient).toLocaleLowerCase().includes(filterQuery.toLocaleLowerCase()));

    return (
        <div className='dialog'>
            <h1 className={`title ${styles.title}`}>
                {t('assign_device')}
            </h1>
            <h2 className={`subtitle ${styles.subtitle}`}>{device.device_type?.description} {device.model?.manufacturer?.name || ''} {device.model?.name || ''}</h2>
            <div className={styles.content}>
                <p className={styles.selectPatient}>{t('select_patient')}</p>
                <div className={styles.searchBarContainer}>
                    <Searchbar handleChange={changeSearchbar} />
                </div>
                <div className={styles.patientList}>
                    {filteredPatients.map(patient =>
                        <CheckboxButton
                            key={patient.id}
                            label={getFullName(patient)}
                            checked={selectedPatientID === patient.id}
                            onClick={() => handleClickPatient(patient.id || null)}
                        />
                    )}
                </div>
                <CancelConfirmButtons
                    onCancel={() => setShowModal(false)}
                    onConfirm={handleConfirm}
                    confirmName={t('assign') as string}
                />
            </div>
        </div>
    );
};

export default DialogAssignDevice;